import IToolsForMarketing from "../interfaces/models/tools-for-marketing.interface";

export const ToolsForMarketing: IToolsForMarketing[] = [
  {
    id: 1,
    title: "ToolsForMarketingConstant/t-01",
    description: "ToolsForMarketingConstant/des-01",
    image:
      "https://cdn.1cdn.app/application/LOUISEBOT/23100208270423_Fine_Tune_2.png",
    active: true
  },

  {
    id: 2,
    title: "ToolsForMarketingConstant/t-02",
    description: "ToolsForMarketingConstant/des-02",
    image:
      "https://cdn.1cdn.app/application/LOUISEBOT/23100208270487_Conditional_Scenario.png",
    active: false
  },

  {
    id: 3,
    title: "ToolsForMarketingConstant/t-03",
    description: "ToolsForMarketingConstant/des-03",
    image:
      "https://cdn.1cdn.app/application/LOUISEBOT/23100208270448_Fine_Tune_3.png",
    active: false
  }
];
